import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories: [],
  isCalledCategories: false,
};

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategories(state, action) {
      state.categories = action.payload || [];
    },
    clearCategories(state) {
      state.categories = [];
    },
    setCalledCategories(state, action) {
      state.isCalledCategories = action.payload || false;
    }
  },
});

export const { setCategories, clearCategories, setCalledCategories } =
  categoriesSlice.actions;

export default categoriesSlice.reducer;